import { cn } from '../../lib/cn';

const COLORS = ['#007AFF','#34C759','#FF9500','#FF3B30','#AF52DE','#FF2D55','#5AC8FA','#FFCC00'];
const colorFor = (name) => COLORS[(name?.charCodeAt(0) || 0) % COLORS.length];

export function Avatar({ name, src, size = 'md', className }) {
  const sizes = { xs:'w-6 h-6 text-[10px]', sm:'w-8 h-8 text-xs', md:'w-9 h-9 text-[13px]', lg:'w-12 h-12 text-base', xl:'w-16 h-16 text-xl' };
  const initials = name ? name.split(' ').map(w=>w[0]).slice(0,2).join('').toUpperCase() : '?';
  if (src) return <img src={src} alt={name} className={cn('rounded-full object-cover', sizes[size], className)} />;
  return (
    <div className={cn('rounded-full flex items-center justify-center text-white font-semibold shrink-0', sizes[size], className)} style={{ backgroundColor: colorFor(name) }}>
      {initials}
    </div>
  );
}
export default Avatar;
